<template>
  <router-link
    class="table-router-link"
    :to="{ name: 'Card', params: { id: row.id }, query: filterParams }"
  >
    {{ row.user.full_name }}
  </router-link>
</template>

<script>

export default {
  name: "router-link-to-card-column-template",
  components: {},

  props: {
    row: {type: Object, required: true},
    filterParams: {type: Object, required: false}
  },

  data() {
    return {}
  },
  mounted() {
  },
  watch: {},
  computed: {},
  methods: {},

}
</script>

<style>
.table-router-link {
  text-decoration: none;
}
</style>